import noop from 'lodash/noop'
import omit from 'lodash/omit'

import { FormProps } from '~/common/types/form'
import { STORAGE_KEY, IGNORED_FORM_KEYS } from '~/form/constants'

const saveFormValuesToStorage = (values: FormProps) => {
  const filteredValues = omit(values, IGNORED_FORM_KEYS)
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(filteredValues))
  } catch (error) {
    noop()
  }
}

export default saveFormValuesToStorage
